const ActionTypes = {
  GET_EXTRA_OPTIONS: '[Application] Get Extra Options',
  GET_EXTRA_OPTIONS_SUCCESS: '[Application] Get Extra Options Success',
  GET_EXTRA_OPTIONS_FAIL: '[Application] Get Extra Options Fail',
}

export class GetExtraOptions {
  static type = ActionTypes.GET_EXTRA_OPTIONS;
}

export class GetExtraOptionsSuccess {
  static type = ActionTypes.GET_EXTRA_OPTIONS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetExtraOptionsFail {
  static type = ActionTypes.GET_EXTRA_OPTIONS_FAIL;
}